import { Component, Input, OnInit } from '@angular/core';
import { BaseFormControlComponent } from '../../../../shared/components/form-inputs/base-form-control.component';

@Component({
  selector: 'boi-form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.scss']
})
export class FormCheckboxComponent extends BaseFormControlComponent implements OnInit {
  internalValue: boolean;
  @Input() checkboxLabel: string;
  @Input() trueValue: string;
  @Input() falseValue: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.onValueChange();
    this.updateCheckbox();
  }

  updateCheckbox(): void {
    this.value = this.internalValue ? this.trueValue : this.falseValue;
    this.valueChange.emit(this.value);
  }

  public onValueChange = (): void => {
    this.internalValue = this.value === this.trueValue;
  };
}
